const podTypeEnum = {
  PICKUP: 'Coleta',
  DELIVERY: 'Entrega',
  LOADING: 'Carregamento',
  UNLOADING: 'Descarregamento',
  RETURN: 'Devolução',
};

export default podTypeEnum;
